import Vue from 'vue';

export default {
  name: 'customButton',
  props: {
    value: {
      type: Number,
      default: 0,
    },
    isVisable: {
      type: Boolean,
      default: true
    },
    onClick: {
      type: Function
    }
  },
  methods: {
    callClick() {
      if (this.onClick)
        this.onClick();
    }
  }
}
